<block-ui>
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button *ngFor="let Tab of Tabs" class="nav-link"
                id="nav-{{Tab}}-tab" data-toggle="tab" role="tab"
                aria-controls="nav-{{Tab}}"
                [ngClass]="{active:(SelectTab==Tab)}"
                (click)="SelectTab=Tab; LoadTab(Tab)">{{Tab}}</button>
        </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
        <div [ngClass]="{'show': (SelectTab=='Roles'), 'active':(SelectTab=='Roles')}"
            id="nav-Roles" role="tabpanel"
            [hidden]="(SelectTab!='Roles')"
            aria-labelledby="nav-Roles-tab">
            <app-roles></app-roles>
        </div>
        <div [ngClass]="{'show': (SelectTab=='Permisos'), 'active':(SelectTab=='Permisos')}"
            id="nav-Permisos" role="tabpanel"
            [hidden]="(SelectTab!='Permisos')"
            aria-labelledby="nav-Permisos-tab">
            <app-premissions></app-premissions>
        </div>
    </div>
</block-ui>